import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const createNewCompanyAndAdmin = async (data: any) => {
  return await axiosInstance
    .post("user/create", data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useCreateNewCompanyAndAdmin = () => {
  return useMutation({
    mutationKey: ["user", "company", "notification"],
    mutationFn: (value: any) => createNewCompanyAndAdmin(value),
  });
};

export default useCreateNewCompanyAndAdmin;
